import { Record } from "immutable";

import { LOAD_USER_SUCCESS } from "./action-types";

import { SIGN_OUT_SUCCESS } from "../auth";

export const UserState = new Record({
  displayName: null,
  email: null,
  photoURL: null,
  uid: null,
  affiliate: null,
  cyclone: null,
});

export function userReducer(state = new UserState(), { payload, type }) {
  switch (type) {
    case LOAD_USER_SUCCESS:
      return { ...state, ...payload };

    case SIGN_OUT_SUCCESS:
      return new UserState();

    default:
      return state;
  }
}



/** WEBPACK FOOTER **
 ** ./src/core/user/reducer.js
 **/